import React from "react";
import { FaRegTrashAlt, FaRegCircle } from "react-icons/fa";

import QuestionTypeSelector from "./QuestionTypeSelector";
import MoodSelector from "../MoodSelector";

const CreateQueBoilerPlateCard = ({ question, onChange, onRemove }) => {
  const update = (updates) => {
    onChange({ ...question, ...updates });
  };

  const updateAnswer = (id, text) => {
    update({
      answers: question.answers.map((a) => (a.id === id ? { ...a, text } : a)),
    });
  };

  const addAnswer = () => {
    update({
      answers: [...question.answers, { id: crypto.randomUUID(), text: "" }],
    });
  };

  const removeAnswer = (id) => {
    update({
      answers: question.answers.filter((a) => a.id !== id),
    });
  };

  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-6 mt-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <QuestionTypeSelector
          value={question.type}
          onChange={(type) => update({ type })}
        />

        <button
          onClick={() => onRemove(question.id)}
          className="p-2 rounded-full text-slate-400 hover:text-red-500 hover:bg-slate-100 transition"
        >
          <FaRegTrashAlt fontSize="small" />
        </button>
      </div>

      {/* Question text */}
      <div className="flex flex-col mb-6">
        <label className="text-sm font-semibold text-slate-600 mb-2">
          Question
        </label>
        <input
          type="text"
          value={question.text}
          onChange={(e) => update({ text: e.target.value })}
          placeholder="Enter your question"
          className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-mpPurple"
        />
      </div>

      {question.type === "mood" && (
        <div className="mt-6">
          <label className="text-sm font-semibold text-slate-600 mb-3 block">
            Mood preview
          </label>

          <MoodSelector disabled />
        </div>
      )}

      {/* Answers */}
      {(question.type === "single" || question.type === "multi") && (
        <div className="flex flex-col">
          <label className="text-sm font-semibold text-slate-600 mb-3">
            Answers
          </label>

          <div className="flex flex-col gap-3">
            {question.answers.map((answer, index) => (
              <div key={answer.id} className="flex items-center gap-3">
                <span className="text-slate-400 text-sm w-6">{index + 1}.</span>

                <input
                  type="text"
                  value={answer.text}
                  onChange={(e) => updateAnswer(answer.id, e.target.value)}
                  placeholder="Answer option"
                  className="flex-1 px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-mpPurple"
                />

                {question.answers.length > 1 && (
                  <button
                    onClick={() => removeAnswer(answer.id)}
                    className="p-2 rounded-full text-slate-400 hover:text-red-500 hover:bg-slate-100"
                  >
                    <FaRegTrashAlt fontSize="small" />
                  </button>
                )}
              </div>
            ))}
          </div>

          <button
            onClick={addAnswer}
            className="flex items-center gap-2 mt-4 text-mpPurple font-semibold hover:opacity-80"
          >
            <FaRegCircle />
            Add Answer
          </button>
        </div>
      )}
    </div>
  );
};

export default CreateQueBoilerPlateCard;
